import { MODULES_BY_KEY } from "@/config/modules";

export default function ComingSoonPage({ moduleKey }) {
  const mod = MODULES_BY_KEY[moduleKey];
  const Icon = mod?.icon;
  return (
    <div className="flex flex-col items-center justify-center py-24 text-center" data-testid={`coming-soon-${moduleKey}`}>
      {Icon && (
        <div className="h-14 w-14 rounded-lg bg-slate-900 flex items-center justify-center mb-4">
          <Icon className="h-6 w-6 text-amber-500" />
        </div>
      )}
      <h1 className="text-xl font-bold text-slate-900" style={{ fontFamily: "Outfit, sans-serif" }}>
        {mod?.title}
      </h1>
      <p className="text-sm text-slate-500 mt-2 max-w-md">
        {mod?.description} This module is being ported from mobile next and will land here soon.
      </p>
    </div>
  );
}
